/** 确认接口 必填参数 是否为空: { k: msg } */
export function checkParamsIsEmpty(checkAttrs, obj, fn) {
  const keys = Object.keys(checkAttrs);

  // eslint-disable-next-line no-restricted-syntax
  for (const key of keys) {
    if (isEmpty(obj[key])) {
      fn && fn(checkAttrs[key]);
      return true;
    }
  }
  return false;
}

/** 
 * @description 生成对象 map
 * @param {string | string[]} attrs
 * @param {function | boolean | number | string} initialVal   */
export function makeMap(attrs, initialVal) {
  let keys;
  if (typeof attrs === 'string') {
    keys = attrs.replace(/\s/, '').split(',');
  } else {
    keys = attrs;
  }
  const map = {};

  keys.forEach(it => {
    map[it] = typeof initialVal === 'function' ? initialVal(it) : initialVal ?? true;
  });

  return map;
}

/** 
 * @description 生成对象集合
 * @param {any} objs
 * @param {?string} key */
export function makeMapByObj(objs, key) {
  if (key) {
    const map = new Map();
    objs.forEach(it => map.set(it[key], it));
    return map;
  }
  const map = new Set < T > (objs);
  return map;
}

/** 读取路径取值 */
export function getAttrByPath(obj, attrStr, defaultVal) {
  const attrs = attrStr.replace(/\s/, '').split('.');
  let i = obj;
  try {
    while (attrs.length) {
      i = i[attrs.shift()];
    }
    return i || defaultVal;
  } catch (error) {
    return defaultVal;
  }
}

/** 找到值或对象 */
export function findItem(arr, val, key) {
  if (key) {
    return arr.find(it => it[key] === val);
  }

  return arr.find(it => it === val);
};

/** try catch 包裹执行接口请求 */
export async function invokeApi(fn, params, initalVal) {
  try {
    const res = await fn(params);

    if (res.error) throw new Error(res.error.msg);
    return {
      isError: false,
      data: res.data || initalVal,
      msg: res.msg
    };
  } catch (error) {
    return {
      isError: true,
      data: initalVal,
      msg: error
    };
  }
}

/** 判断 值、对象、数组 是否为空 */
export function isEmpty(val) {
  return (
    val === '' || val == null || ((Array.isArray(val) && val.length) || (typeof val === 'object' && Object.keys(val).length)) === 0
  );
}

/** 枚举和字典生成选项 */
export function dictsToOpts(enums, dicts) {
  return Object.entries(enums).map(it => {
    return { label: dicts[it[1]], value: it[1] }
  })
}

export function enumToOpts(enums) {
  return Object.entries(enums).map(([value, label]) => {
    return {
      label,
      value: Number(value)
    }
  })
}

export function setSearchListOpts(list, map) {
  list.forEach(it => {
    if (it.key in map) {
      it.opts = map[it.key]
    }
  })
}

/** 时间数组打散解包 */
export function timeUnpack(obj, keys, prefixs, isReverse) {
  const newObj = { ...obj }
  const prefixArr = prefixs.split(",")
  keys.split(',').forEach((key, idx) => {
    if (!isEmpty(obj[key])) {
      const vals = obj[key] || []
      if (isReverse) {
        Object.assign(newObj, {
          ['start' + prefixArr[idx]]: vals[0] || "",
          ['end' + prefixArr[idx]]: vals[1] || "",
        })
      } else {
        Object.assign(newObj, {
          [prefixArr[idx] + 'Start']: vals[0] || "",
          [prefixArr[idx] + 'End']: vals[1] || "",
        })
      }
    }
    delete newObj[key]
  })
  return newObj
}

/** 重置对象 */
export function resetData(obj, skipMap = {}) {
  if (typeof skipMap === "string") {
    skipMap = makeMap(skipMap)
  }
  Object.keys(obj).forEach(key => {
    if (!(key in skipMap)) {
      switch (typeof obj[key]) {
        case 'boolean':
          obj[key] = false
          break;
        case 'number':
          obj[key] = ''
          break;
        case 'string':
          obj[key] = ''
          break;
        case 'object':
          if (Array.isArray(obj[key])) {
            obj[key] = []
          } else if (obj[key]) {
            resetData(obj[key], skipMap)
          } else {
            obj[key] = undefined
          }
          break;
      }
    }
  })
}

/** 生成必填 rules，并允许附加一个自定义 */
export function getRequiredRules(obj, additional = {}) {
  const rules = {}
  Object.entries(obj).forEach(([key, message]) => {
    rules[key] = [
      { required: true, message, trigger: "blur" },
    ]

    if (key in additional) {
      rules[key].push(additional[key])
    }
  })
  return rules
}

export function scanExcludeEmptyChildren(it) {
  if (Array.isArray(it)) {
    it.forEach(scanExcludeEmptyChildren)
  } else {
    if (it.children.length) {
      it.children.forEach(scanExcludeEmptyChildren)
    } else {
      Reflect.deleteProperty(it, 'children')
    }
  }
  return it
}